import { combineReducers } from '@reduxjs/toolkit';
import authSlice from '../features/auth/auth.slice';
import productSlice from '../features/store/products/product.slice';
import planSlice from '../features/plans/plan.slice';
import membershipSlice from '../features/memberships/membership.slice';
import attendanceSlice from '../features/attendance/attendance.slice';
import staffAttendanceSlice from '../features/attendance/staff-attendance.slice';
import businessPaymentSlice from '../features/business-payments/business-payment.slice';
import memberPaymentSlice from '../features/member-payments/member-payment.slice';
import businessSlice from '../features/business/business.slice';
import billingSlice from '../features/billing/billing.slice';
import memberSlice from '../features/members/member.slice';
import noteSlice from '../features/notes/note.slice';
import alertSlice from '../features/alerts/alert.slice';
import userDashboardSlice from '../features/dashboard/user-dashboard.slice';
import memberDashboardSlice from '../features/dashboard/member-dashboard.slice';
import adminDashboardSlice from '../features/dashboard/admin-dashboard.slice';
import userSlice from '../features/user/user.slice';
import roleSlice from '../features/roles/role.slice';
import memberMessageSlice from '../features/message/member-message.slice';
import businessMessageSlice from '../features/message/business-message.slice';
import batchSlice from '../features/store/product-batch/product-batch.slice';
import saleSlice from '../features/store/sales/sale.slice';
import saleCartSlice from '../features/store/sale-cart.slice';
import unitSlice from '../features/units/unit.slice';
import mealItemSlice from '../features/nutrition/meal-items/meal-item.slice';
import nutritionPlanSlice from '../features/nutrition/nutrition-plan/nutrition-plan.slice';
import workoutPlanSlice from '../features/workout/workout-plan/workout-plan.slice';
import exerciseSlice from '../features/workout/exercise/exercise.slice';
import permissionSlice from '../features/permission/permission.slice';
import biometricDeviceSlice from '../features/biometric-device/biometric-device.slice';
import biometricUserSlice from '../features/biometric-user/biometric-user.slice';
import biometricTransactionSlice from '../features/biometric-transaction/biometric-transaction.slice';

const rootReducer = combineReducers({
    auth: authSlice,
    products: productSlice,
    plans: planSlice,
    memberships: membershipSlice,
    attendance: attendanceSlice,
    staffAttendance: staffAttendanceSlice,
    businessPayments: businessPaymentSlice,
    memberPayments: memberPaymentSlice,
    billing: billingSlice,
    alerts: alertSlice,
    business: businessSlice,
    member: memberSlice,
    note: noteSlice,
    userDashboard: userDashboardSlice,
    memberDashboard: memberDashboardSlice,
    adminDashboard: adminDashboardSlice,
    users: userSlice,
    roles: roleSlice,
    memberMessages: memberMessageSlice,
    businessMessages: businessMessageSlice,
    productBatches: batchSlice,
    sales: saleSlice,
    saleCart: saleCartSlice,
    units: unitSlice,
    mealItems: mealItemSlice,
    nutritionPlans: nutritionPlanSlice,
    workoutPlans: workoutPlanSlice,
    exercises: exerciseSlice,
    permissions: permissionSlice,
    biometricDevices: biometricDeviceSlice,
    biometricUsers: biometricUserSlice,
    biometricTransactions: biometricTransactionSlice,
});

export default rootReducer;
